/**
 * URL and search parameter utilities
 */

/**
 * Updates search parameters while maintaining clean URLs
 * @param searchParams - Current URLSearchParams
 * @param updates - Object with key-value pairs to update
 * @returns New URLSearchParams object
 */
export const updateSearchParams = (
  searchParams: URLSearchParams,
  updates: Record<string, string>,
): URLSearchParams => {
  const newParams = new URLSearchParams(searchParams)

  Object.entries(updates).forEach(([key, value]) => {
    if (value === 'all' || value === '') {
      newParams.delete(key)
    } else {
      newParams.set(key, value)
    }
  })

  return newParams
}

/**
 * Clears all filter parameters from search params except page
 * @param searchParams - Current URLSearchParams
 * @returns New URLSearchParams with filters cleared
 */
export const clearAllFilters = (searchParams: URLSearchParams): URLSearchParams => {
  const newParams = new URLSearchParams()
  // Preserve non-filter params if needed
  const page = searchParams.get('page')
  if (page && page !== '1') {
    newParams.set('page', page)
  }
  return newParams
}
